import React, { useState } from 'react';

const ImageSelector = ({ value, onChange }) => {
  const [showSelector, setShowSelector] = useState(false);
  
  // Available fish images from your collection
  const availableImages = [
    '/images/anthias.jpg',
    '/images/blue-tang.jpg',
    '/images/yellow-tang.jpg',
    '/images/clownfish.jpg',
    '/images/mandarin-dragonet.jpg',
    '/images/emperor-angelfish.jpg',
    '/images/flame-angelfish.jpg',
    '/images/parrotfish.jpg',
    '/images/wrasse.jpg',
    '/images/dragon-wrasse.jpg',
    '/images/goby.jpg',
    '/images/fire-goby.jpg',
    '/images/sleeper-goby.jpg',
    '/images/damselfish.jpg',
    '/images/butterflyfish.jpg',
    '/images/bannerfish.jpg',
    '/images/surgeonfish.jpg',
    '/images/unicornfish.jpg',
    '/images/grouper.jpg'
  ];

  const handleImageSelect = (imagePath) => {
    onChange(imagePath);
    setShowSelector(false);
  };

  const handleRemove = () => {
    onChange('');
  };

  return (
    <div style={{ marginBottom: '15px' }}>
      <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
        Fish Image
      </label>
      
      {/* Current Image Display */}
      {value && (
        <div style={{ marginBottom: '15px', position: 'relative', display: 'inline-block' }}>
          <img 
            src={value} 
            alt="Selected fish"
            style={{
              width: '200px',
              height: '150px',
              objectFit: 'cover',
              borderRadius: '8px',
              border: '2px solid var(--border)'
            }}
          />
          <button
            type="button"
            onClick={handleRemove}
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              background: 'var(--coral)',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '25px',
              height: '25px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            ×
          </button>
        </div>
      )}

      {/* Select Image Button */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
        <button
          type="button"
          onClick={() => setShowSelector(!showSelector)}
          className="admin-button"
          style={{ fontSize: '14px' }}
        >
          🖼️ {value ? 'Change Image' : 'Select Image'}
        </button>
        {value && (
          <button
            type="button"
            onClick={handleRemove}
            className="admin-button"
            style={{
              background: 'var(--coral) !important',
              borderColor: 'var(--coral) !important',
              fontSize: '14px'
            }}
          >
            🗑️ Remove Image
          </button>
        )}
      </div>

      {/* Image Selector Grid */}
      {showSelector && (
        <div style={{
          border: '2px solid var(--border)',
          borderRadius: '8px',
          padding: '15px',
          background: 'var(--muted)',
          maxHeight: '400px',
          overflowY: 'auto'
        }}>
          <h4 style={{ marginTop: 0, marginBottom: '15px', color: 'var(--foreground)' }}>
            Choose from our fish collection:
          </h4>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
            gap: '10px'
          }}>
            {availableImages.map((imagePath, index) => (
              <div
                key={index}
                onClick={() => handleImageSelect(imagePath)}
                style={{
                  cursor: 'pointer',
                  borderRadius: '6px',
                  overflow: 'hidden',
                  border: value === imagePath ? '3px solid var(--ocean-light)' : '2px solid transparent',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  if (value !== imagePath) {
                    e.target.style.borderColor = 'var(--border)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (value !== imagePath) {
                    e.target.style.borderColor = 'transparent';
                  }
                }}
              >
                <img 
                  src={imagePath}
                  alt={`Fish option ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '80px',
                    objectFit: 'cover',
                    display: 'block'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            ))}
          </div>
          <div style={{ marginTop: '15px', textAlign: 'center' }}>
            <button
              type="button"
              onClick={() => setShowSelector(false)}
              className="admin-button"
              style={{ fontSize: '12px' }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <p style={{ 
        fontSize: '12px', 
        color: 'var(--muted-foreground)', 
        marginTop: '10px',
        fontStyle: 'italic'
      }}>
        💡 Select from our high-quality fish images to avoid storage limits
      </p>
    </div>
  );
};

export default ImageSelector;